import { Individualprofile } from '@/payload-types';
import React from 'react';
import Image from 'next/image'

interface IProps {
    profiles?: Individualprofile[];
    maxDisplay?: number;
}

export const AvatarGroup = ({ profiles, maxDisplay = 3 }: IProps) => {
    if (!profiles || profiles.length === 0) return null
    const displayedUsers = profiles.slice(0, maxDisplay);
    const remainingCount = profiles.length - maxDisplay;
   
    return (
        <div className="flex items-center">
            <div className="flex -space-x-4">
                {displayedUsers.map((profile, index) => {
                    const imageUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''}${
                        typeof profile?.publicProfile === 'object' &&
                        typeof profile?.publicProfile?.profileImage === 'object'
                        ? profile?.publicProfile?.profileImage?.sizes?.webp?.url
                        : ''
                    }`
                    return (
                    <div
                        key={profile.id}
                        className="relative"
                        style={{ zIndex: index }}
                    >
                        <Image
                            src={imageUrl}
                            alt={`${profile.fullName}`}
                            className="w-[48px] h-[48px] rounded-full border-2 border-white object-cover"
                            width={48}
                            height={48}
                        />
                    </div>)
                })}
                {remainingCount > 0 && (
                    <div
                        className="relative flex items-center justify-center w-[48px] h-[48px] rounded-full bg-gray-900 border-2 border-white text-md text-white font-medium"
                        style={{ zIndex: displayedUsers.length }}
                    >
                        +{remainingCount}
                    </div>
                )}
            </div>
        </div>
    );
};
